import { useEffect, useState } from 'react';
import { api } from './api';

let cache = null;
let inflight = null;

export const TIER_NAMES = {
  ds: 'Starter',
  fe: 'IDOLARIS Creator',
  oto1: 'Pro Unlimited',
  oto2: 'Campaign Engine',
  oto3: 'Agency',
  oto4: 'Whitelabel',
};

export async function loadEntitlements(force = false) {
  if (!force && cache) return cache;
  if (!inflight) {
    inflight = api.getEntitlements()
      .then((e) => { cache = e; inflight = null; return e; })
      .catch(() => { inflight = null; return null; });
  }
  return inflight;
}

export function clearEntitlements() { cache = null; }

// Optimistic: while loading (ent null) treat features as available to avoid lock flicker.
export function useEntitlements() {
  const [ent, setEnt] = useState(cache);
  useEffect(() => { loadEntitlements().then((e) => e && setEnt(e)); }, []);
  const has = (f) => (!ent ? true : (ent.features || []).includes(f));
  const tierFor = (f) => (ent && ent.feature_tier ? ent.feature_tier[f] : 'oto1');
  return { ent, has, tierFor };
}

export function useBranding() {
  const { ent } = useEntitlements();
  const b = (ent && ent.branding) || {};
  return { name: b.name || 'Idolaris', logo: b.logo_url || '', accent: b.accent || '#22D3EE' };
}
